// extracted by mini-css-extract-plugin
export var content = "_c9-3";
export var list = "_c9-4";
export var settingsContent = "_c9-7";
export var settingsPanel = "_c9-8";
export var state = "_c9-6";
export var triggerBadge = "_c9-2";
export var triggerButton = "_c9-1";
export var triggerShell = "_c9-0";
export var unreadDot = "_c9-5";